import React, { useCallback, useEffect, useState } from "react";
import { usePlaidLink } from "react-plaid-link";
import { Box, Spinner } from "theme-ui";
import BasicButton from "components/forms/BasicButton";
import { BankIcon } from "components/svg";
import { createLinkToken } from "api/Plaid";

interface PlaidLinkButtonProps {
  onSuccess: (publicToken: string, metadata: any) => void;
  onExit?: () => void;
  buttonText?: string;
  isSubmitting?: boolean;
}

const PlaidLinkButton: React.FC<PlaidLinkButtonProps> = ({
  onSuccess,
  onExit,
  buttonText = "Connect Bank Account",
  isSubmitting = false
}) => {
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const getToken = async () => {
      setLoading(true);
      try {
        const response = await createLinkToken();
        if (response?.link_token) {
          setToken(response.link_token);
        } else {
          console.error("Failed to get link token", response);
        }
      } catch (error: any) {
        console.error("Error getting link token", error);
      } finally {
        setLoading(false);
      }
    };

    getToken();
  }, []);

  const onPlaidSuccess = useCallback(
    (publicToken: string, metadata: any) => {
      onSuccess(publicToken, metadata);
    },
    [onSuccess]
  );

  const onPlaidExit = useCallback(() => {
    if (onExit) {
      onExit();
    }
  }, [onExit]);

  const { open, ready } = usePlaidLink({
    token,
    onSuccess: onPlaidSuccess,
    onExit: onPlaidExit,
  });

  const handleClick = () => {
    if (ready) {
      open();
    }
  };

  console.log("PlaidLinkButton rendering with values:", {
    loading,
    ready,
    token,
    isSubmitting
  });
  return (
    <BasicButton
    type="button"
    scheme="secondaryOutline"
    onClick={handleClick}
    $submitting={isSubmitting}
    $iconHeight="14px"
    $iconWidth="14px"
    $loadingColor="#000"
    keepText={true}
    disabled={!ready || !token || loading}
  >
    {buttonText && (
      <>
        {isSubmitting ? (
          <>
            <Spinner size={14} color="#000" />
            <span style={{ marginLeft: "6px" }}>{buttonText}</span>
          </>
        ) : (!ready || !token || loading) ? (
          <>
            <Spinner size={14} color="#000" />
            <span style={{ marginLeft: "6px" }}>{buttonText}</span>
          </>
        ) : (
          <>
            <BankIcon fill={"#000"} />
            <span style={{ marginLeft: "6px" }}>{buttonText}</span>
          </>
        )}
      </>
    )}
  </BasicButton>
  );
};

export default PlaidLinkButton;